import {Avatar} from 'antd'
import {getType} from 'apis/model/base'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {AppEntities, fromAppEntity} from 'views/AppLocals/enums'
import EventContext from 'views/AppLocals/Event/EventContext'
import OrganizationContainerContext from 'views/AppLocals/Organization/OrganizationContainerContext'
import {LoadingWrapper, renderElse, renderOwnChild} from 'views/Shared'
import {OrgType} from '../../Organization/components/OrgType'
import {BiSolidChurch} from "react-icons/bi";
import {HeaderBlock} from "../../../MainPage/components/HeaderBlock";

const renderHostByItem = ({host, owner, host_name, ...rest}, index) => {
    const title = host_name || getTitle(host)
    const type = getType(host)

    return (
        <Translate key={index}>
            {(t) => (
                <div className="flex items-center gap-2">
                    <Avatar
                        size={36}
                        src={_.get(host, 'avatar')}
                        icon={<BiSolidChurch className="text-color-300"/>}
                        className="flex flex-center background-200 border border-color-50 rounded-md"
                    />
                    <div className="flex flex-col flex-1">
                        <Link
                            className="font-bold text-sm text-primary-600 max-lines-1 no-underline leading-snug"
                            to={getLinkToDetail(host)}>
                            {title}
                        </Link>
                        <span className="font-medium text-xs text-blue-500 italic leading-tight">
                            {type === 'organization' ? <OrgType item={host}/> : t(type)}
                        </span>
                    </div>
                </div>
            )}
        </Translate>
    )
}

const createHostList =
    (type, Context) =>
        ({id_field = 'id', host_field = 'hosts', Wrapper = renderOwnChild}) => {
            const t = useTranslate()

            const context = useContext(Context)

            const {contextName} = fromAppEntity(type)

            const entity = _.get(context, contextName)

            const items = Array.from(_.get(entity, host_field) ?? [])

            return renderElse(
                _.isEmpty(items),
                <Wrapper>
                    <LoadingWrapper isLoading={_.isEmpty(items)}>
                        <div className="flex flex-col gap-3">
                            <HeaderBlock
                                size={26}
                                icon={<BiSolidChurch size={14} className="text-color-400"/>}
                                title="co-hosts"
                                className="background-200 text-sm text-color-200"
                            />
                            <div className="ml-2 flex flex-col gap-3">
                                {items.map(renderHostByItem)}
                            </div>
                        </div>
                    </LoadingWrapper>
                </Wrapper>
            )
        }

export const OrganizationHosts = createHostList(
    AppEntities.ORGANIZATION,
    OrganizationContainerContext
)

export const EventHosts = createHostList(AppEntities.EVENT, EventContext)
